import pipe from './pipe';
import { DateTime } from 'luxon';

/**
 * Place the value of `placements` object index in string in respective index.
 *
 * @param {Object.<Number, string>} placements - index-value mapping
 */
const replacements = placements => str => str
  .split('')
  .reduce((fmtd, c, i) => i in placements ? `${fmtd}${placements[i]}${c}` : `${fmtd}${c}`, '');

/**
 * Generate `replacements` function `placements` argument by analising a string.
 * Whenever a character is different than `base` in the provided string, add to resulting object a
 * mapping { [index]: character } where index is the index of the current non-base character less
 * the number of already mapped characters.
 *
 * @param {string} str - The string to be compiled
 * @param {string=} base - Single character string
 * @returns {Object.<Number, string>} Index-character mapping
 */
const compile = (str, base = '_') => str
  .split('')
  .reduce(
    (placements, c, i) => {
      const effectiveIndex = i - Object.keys(placements).length;

      return c === base ? placements : Object.assign(placements, { [effectiveIndex]: c });
    },
    {}
  );

export const numbersOnly = str => str.replace(/\D/g, '');
const alphaNumericOnly = str => str.replace(/[^a-zA-Z0-9]/g, '');

export const cpf = pipe(numbersOnly, replacements(compile('___.___.___-__')));
export const cnpj = pipe(alphaNumericOnly, replacements(compile('__.___.___/____-__')));

export const document = str => {
  if (!str) return '';

  str = alphaNumericOnly(str);

  const formatted = str.length > 11
    ? cnpj(str)
    : cpf(str);

  return formatted;
};

export const isoDate = iso => iso
  ? DateTime
    .fromISO(iso, { setZone: true })
    .toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)
  : null;

export const dateOnly = date => date
  ? DateTime
    .fromISO(date, { setZone: true })
    .toLocaleString(DateTime.DATE_SHORT)
  : null;